"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
/** Actions possible */
var ACTION;
(function (ACTION) {
    ACTION["CREATE"] = "create";
    ACTION["DECLARE_SENT_PAYMENT"] = "declareSentPayment";
    ACTION["DECLARE_RECEIVED_PAYMENT"] = "declareReceivedPayment";
    ACTION["DECLARE_SENT_REFUND"] = "declareSentRefund";
    ACTION["DECLARE_RECEIVED_REFUND"] = "declareReceivedRefund";
    ACTION["ADD_PAYMENT_INSTRUCTION"] = "addPaymentInstruction";
    ACTION["ADD_REFUND_INSTRUCTION"] = "addRefundInstruction";
    ACTION["ADD_DELEGATE"] = "addDelegate";
})(ACTION || (exports.ACTION = ACTION = {}));
